import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfileData } from '../../models/profile/profile.model';
import { UserTokenService } from '../user-service/user-token.service';
import { AdminMandant } from '../../models/cloud/cloud.model';

@Injectable()
export class UserProfileShareService {

  private profile: Subject<ProfileData>;
  private adminMandant: Subject<AdminMandant>;
  private isDealerPartner: Subject<boolean>;
  private IsPremiumProjectPartner: Subject<boolean>;
  private rights: BehaviorSubject<string[]>;

  constructor(private userTokenService: UserTokenService) {
    this.profile = new BehaviorSubject<ProfileData>(null);
    this.adminMandant = new BehaviorSubject<AdminMandant>(null);
    this.isDealerPartner = new BehaviorSubject<boolean>(null);
    this.IsPremiumProjectPartner = new BehaviorSubject<boolean>(null);
    this.rights = new BehaviorSubject<string[]>([]);
  }

  public getProfile(): Observable<ProfileData> {
    return this.profile.asObservable();
  }

  public setProfile(newProfile: ProfileData): void {
    this.userTokenService.setName(newProfile?.User.FirstName ? (newProfile?.User.FirstName + ' ' + newProfile?.User.LastName) : '');
    this.userTokenService.setLocale(newProfile?.User.LanguageCode ?? '');
    this.userTokenService.setCurrency(newProfile?.CurrencyCode ?? '');
    this.userTokenService.setId(newProfile?.User.Id ?? 0);

    this.profile.next(newProfile);

    const tenants = newProfile?.Tenants ?? [];
    const roles = newProfile?.Roles ?? [];
    const rights = newProfile?.Rights ?? [];

    this.isDealerPartner.next(this.computeIsDealerPartner(tenants));
    this.IsPremiumProjectPartner.next(this.computeIsPremiumProjectPartner(tenants));
    this.setRights(rights);
  }

  public getAdminMandant(): Observable<AdminMandant> {
    return this.adminMandant.asObservable();
  }

  public setAdminMandant(newAdminMandant: AdminMandant): void {
    this.adminMandant.next(newAdminMandant);
  }

  public getIsDealerPartner(): Observable<boolean> {
    return this.isDealerPartner.asObservable();
  }

  public getIsPremiumProjectPartner(): Observable<boolean> {
    return this.IsPremiumProjectPartner.asObservable();
  }

  public getRights(): Observable<string[]> {
    return this.rights.asObservable();
  }

  public setRights(newRights: string[]): void {
    this.rights.next(newRights ?? []);
  }

  public hasRight(right: string): boolean {
    return this.rights.getValue().includes(right);
  }

  public hasRight$(right: string): Observable<boolean> {
    return this.getRights().pipe(
      map(rights => (rights ?? []).includes(right))
    );
  }

  public computeIsDealerPartner(mandants: AdminMandant[]): boolean {
    // return is dealer partner if there is at least one is finstral false
    return mandants.some(m => m.IsFinstral === false);
  }

  public computeIsPremiumProjectPartner(mandants: AdminMandant[]): boolean {
    // return is premium if there is at least one is premium true
    return mandants.some(m => m.IsPremium === true);
  }
}
